import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { BidService } from "../../../services/bids.service";
import { BidStatus } from "../../../interfaces/enums";
import { Router } from "@angular/router";

@Component({
  selector: "app-history",
  templateUrl: "./history.component.html",
  styleUrls: ["./history.component.css"],
})
export class HistoryComponent implements OnInit {
  bids: any[] = [];
  error: string | null = null;

  // Pagination related data
  totalItems: number = 0;
  itemsPerPage: number = 10;
  currentPage: number = 1;

  constructor(private bidService: BidService, private router: Router) {}

  ngOnInit(): void {
    this.loadBids(this.currentPage);
  }

  loadBids(page: number): void {
    const offset = (page - 1) * this.itemsPerPage;
    const filter = { limit: this.itemsPerPage, offset: offset };
    this.currentPage = page;
    this.bidService.getFilteredBids(filter).subscribe(
      (data) => {
        if (Array.isArray(data.items)) {
          this.bids = data.items.sort(
            (a: any, b: any) =>
              new Date(b.created_on).getTime() -
              new Date(a.created_on).getTime()
          );
          this.totalItems = data.total_items;
        } else {
          console.error("Data is not an array:", data);
          this.error = "Unexpected data format received from server";
        }
      },
      (error) => {
        console.error("Error loading bids:", error);
        this.error = "Error loading bids: " + error.message;
      }
    );
  }

  onPageChanged(page: number): void {
    this.loadBids(page);
  }

  navigateTo(bid: any) {
    let path = "";
    switch (bid.status) {
      case BidStatus.Active:
      case BidStatus.Closed:
      case BidStatus.Accepted:
        path = "strike";
        break;

      case BidStatus.Rejected:
      case BidStatus.Cancelled:
        path = "allocation";
        break;
      default:
        path = "";
    }
    if (bid.bid_type === "Preferential Exchange of Energy") {
      path = "fixed-rate-bid";
    }
    if (path) {
      this.router.navigate([`/${path}`, bid.id]);
    }
  }
}
